<template>
  <div>
    <app-toolbar></app-toolbar>
    <app-menu></app-menu>
    <app-message></app-message>
    <file-preview></file-preview>
    <v-content>
      <v-container fluid :class="isMobile ? 'pa-0' : 'pa-4'">
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <keep-alive :include="keepAlives">
              <router-view></router-view>
            </keep-alive>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </div>
</template>

<script>
  import AppToolbar from './components/AppToolbar'
  import AppMenu from './components/AppMenu'
  import AppMessage from './components/AppMessage'
  import FilePreview from '../../components/FilePreview'

  export default {
    name: 'home',
    components: {AppToolbar, AppMenu, AppMessage, FilePreview},
    data: () => ({
      keepAlives: [
        'home',
        'bid-list',
        'shipping-list',
        'freight-list',
        'order-list',
        'client-contract-list',
        'driver-contract-list',
        'comment-list',
        'feedback-list',
        'account-bill-list',
        'account-settle-list',
        'account-arap-list',
        'account-flow-list',
        'report-order-finance',
        'group-client',
        'group-account-type',
        'clients',
        'user-logs',
      ]
    }),
  }
</script>
